import React from "react";
import CustomerPromiseIcon from "images/customer-promise.svg";
import { useAppSelector } from "../../../../../util/store-types";
import { isActiveMembership } from "helpers/membership-helpers";

const CustomerPromise = () => {
  const activeMember = useAppSelector(state => isActiveMembership(state.membershipState));
  const membershipStateLoading = useAppSelector(state => state?.membershipStateLoading);

  if (activeMember || membershipStateLoading !== false) {
    return;
  }

  return (
    <div className="p-4 rounded-md text-sm my-6 bg-lightTealGreen">
      <div className="flex mb-1 items-center">
        <CustomerPromiseIcon className="mr-2" />
        <p className="font-semibold">Our Customer Promise</p>
      </div>
      <p className="ml-8">
        If items do not fit right in your first 60 days, you will get free items in your next shipment.
      </p>
    </div>
  );
};

export default CustomerPromise;
